/* Badge classifier - Oferta vs Agotado */
(function(){
  function classifyBadges(){
    document.querySelectorAll('.product-badges__badge').forEach(function(b){
      var txt=b.textContent.trim().toLowerCase();
      if(txt==='agotado'){
        b.classList.add('product-badges__badge--sc-agotado');
        var card=b.closest('.product-card')||b.closest('.card');
        if(card) card.classList.add('sc-card-soldout');
      } else if(txt==='oferta'){
        b.classList.add('product-badges__badge--sc-oferta');
      }
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(classifyBadges,300)})}
  else{setTimeout(classifyBadges,300)}
  // Re-run on navigation
  var obs=new MutationObserver(function(){setTimeout(classifyBadges,200)});
  obs.observe(document.body,{childList:true,subtree:true});
})();
